export default __webpack_public_path__ + "static/media/learose-480w.cddab259.png";